/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  Title: {
    fontWeight: '600',
    marginBottom: '5px',
  },

  formArea: {
    paddingTop: '20px',
  },
  formControl: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  inputControl: {
    border: '1px solid #CED1D6',
    borderRadius: '10px',
    height: '60px',
    padding: '7px 16px',
    width: '100%',
  },
  btns: {
    marginBottom: '16px',
    padding: '16px 22px',
    fontSize: '1rem',
    borderRadius: '10px',
  },
  infoBtn: {
    background: '#CED1D6',
    color: '#8C9099',
    '&:hover': {
      background: '#ced1d6cc',
    },
  },
  textPrimary: {
    color: '#1C999B',
  },
  textGreen: {
    color: theme.palette.primary.adgmGreen,
  },
  weightMedium: {
    fontWeight: '500',
  },
  errorIcon: {
    marginRight: '10px',
  },
  redBtn: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,

    '&:hover': {
      background: theme.palette.primary.main,
      opacity: '0.7',
    },
    '& svg': {
      marginRight: theme.spacing(1),
    },
  },
});

export default styles;
